import React, { createContext, useState, useContext, useRef } from 'react';
import AppContext from '../context';
import {
  CLASSIC_LENS_TAB,
  FRESH_LENS_TAB,
  MAKEUP_TAB,
  LOOKS_TAB,
  language,
  DEFAULT_PRODUCT_PARENT_TAB
} from 'Root/constants';
import content from 'Content/content.json';

const Context = createContext();
export default Context;

const {
  data: {
    looks,
    productInfo: {
      [language]: { classicLens },
    },
  },
} = content;

const initialState = {
  loader: true,
  recommendation: 0,
  timeout: 120000,
  currentLookIndex: -1,
  lookCurrentlyApplied: -1,
  // It's better move to settings here.
  selectedTab: DEFAULT_PRODUCT_PARENT_TAB,
  lensIndex: 0,
  selectedLensType: DEFAULT_PRODUCT_PARENT_TAB,
  recommendedLensType: DEFAULT_PRODUCT_PARENT_TAB,
  tempRecommendedLook: -1,
  tempRecommendedLens: -1,
  actionWillRemove: null,
  VMImageLoaded: false,
  selectedMakeup: {
    blush: null,
    eyeliner: null,
    lipcolors: null,
    eyelashes: null,
    eyeshadow: null,
  },
  isMakeUpApplied: false,
  isLookApplied: false,
  selectedMakeupCategory: 0,
};

const ContextContainer = (props) => {
  const [state, setState] = useState(initialState);
  const { looksCleared, updateForceMakeupReset, lensCleared } = useContext(
    AppContext
  );
  const isLensCleared = useRef();
  isLensCleared.current = {
    lensCleared,
  };
  const { selectedLensType } = state;

  const setVmState = (vmstate) => {
    setState((prevState) => ({
      ...prevState,
      ...vmstate,
    }));
  };

  const onTabClick = (e) => {
    const {
      currentLookIndex,
      selectedTab,
      VMImageLoaded,
      lookCurrentlyApplied,
      isMakeUpApplied,
      lensIndex,
    } = state;
    const tabTargetted = e.currentTarget.dataset.info;
    // incase of same tab
    if (tabTargetted === selectedTab) {
      return;
    }

    // in case of vm image not loaded
    if (!VMImageLoaded) {
      setVmState({ selectedTab: tabTargetted });
      return;
    }

    if (tabTargetted === MAKEUP_TAB) {
      if (
        lookCurrentlyApplied > -1 ||
        (currentLookIndex > -1 && !looksCleared)
      ) {
        setVmState({
          showLookRemovalPopUp: true,
          actionWillRemove: LOOKS_TAB,
        });
        document.body.classList.add('open');
      } else {
        setVmState({ selectedTab: tabTargetted });
      }
      return;
    }

    if (tabTargetted === LOOKS_TAB) {
      if (isMakeUpApplied && !looksCleared) {
        setVmState({
          showLookRemovalPopUp: true,
          actionWillRemove: MAKEUP_TAB,
        });
        document.body.classList.add('open');
        updateForceMakeupReset(false);
      } else {
        setVmState({ selectedTab: tabTargetted });
        if (state.currentLookIndex > -1) {
          const foundLook = looks.find(
            (look, index) => index === state.currentLookIndex
          );
          handleLooksChange(foundLook, state.currentLookIndex);
        }
      }
    }

    if (!lensCleared && isLensTab(tabTargetted)) {
      setVmState({ selectedTab: tabTargetted });
      handleLensChange(lensIndex);
      return;
    }
    setVmState({ selectedTab: tabTargetted });
  };

  const removeAppliedMakeup = () => {
    const currentLook =
      state.currentLookIndex > -1 ? state.currentLookIndex : 0;
    const lookGuid = looks[currentLook]['guid'];
    applyMakeupByLook(lookGuid, currentLook);
    setVmState({ selectedTab: LOOKS_TAB, isMakeUpApplied: false });
  };

  const removeAppliedLook = () => {
    if (state.VMImageLoaded) {
      console.log('vm is loaded and applied look will be removed now');
      // updateForceLookReset(true);
      setTimeout(() => {
        window.YMK && window.YMK.reset();
        applyMakeUpOnLoad();
        const lensIndex = state.lensIndex;
        if (lensIndex > -1 && !lensCleared) {
          applyMakeUpBySku(classicLens[lensIndex]['guid']);
        }
      }, 200);
    }
  };

  const resetSelectedMakeup = () => {
    setVmState({
      selectedMakeup: {
        blush: null,
        eyeliner: null,
        lipcolors: null,
        eyelashes: null,
        eyeshadow: null,
      },
    });
  };

  const applyMakeUpOnLoad = () => {
    const { selectedMakeup } = state;
    Object.keys(selectedMakeup).forEach((el) => {
      if (selectedMakeup[el]) {
        handleShadeChange(selectedMakeup[el], el);
      }
    });
  };

  const applyMakeupByLook = (lookGuid, index) => {
    if (!looksCleared) {
      window.YMK &&
        window.YMK.applyMakeupByLook(lookGuid, (res) => {
          if (res) {
            setVmState({ VMImageLoaded: true });
            window.YMK.snapshot('', (img) => {});
            setVmState({ lookCurrentlyApplied: index, isLookApplied: true });
            if (!lensCleared) {
              //handleLensOnLoad();
            }
          }
          // updateForceLookReset(false);
        });
    }
  };

  const applyMakeUpBySku = (eyeColor) => {
    window.YMK &&
      window.YMK.applyMakeupBySku(eyeColor, (res) => {

        if (res) {
          window.YMK.snapshot('', (img2) => {});
          const tuner = window.YMK.getTuner('eyecontact');
          tuner.setSecondIntensity(15);
          setVmState({ VMImageLoaded: true, isLookApplied: false });
        }
      });
  };

  const handleLensChange = (
    lensIndex,
    lensClicked = 0,
    lensType = selectedLensType
  ) => {
    lensClicked === 1 && setVmState({ tempRecommendedLens: -1 });
    setVmState({ lensIndex, selectedLensType: lensType });

    const lensSKU =
      content.data.productInfo[language][lensType][lensIndex].guid;
    setTimeout(() => {
      !isLensCleared.current.lensCleared && applyMakeUpBySku(lensSKU);
    }, 200);
  };

  const handleLooksChange = (looksObj, index, lensChangedFromList = 0) => {
    if (index === state.lookCurrentlyApplied && state.isLookApplied) {
      return false;
    }
    if (lensChangedFromList === 1) {
      setVmState({ tempRecommendedLook: -1 });
    }
    setVmState({
      currentLookIndex: index,
      isMakeUpApplied: false,
    });
    setTimeout(() => {
      applyMakeupByLook(looksObj['guid'], index);
    }, 200);
  };

  const looksLoaded = (index) => {
    const indexFinal = index > -1 && index != null ? index : 0;
    if (state.selectedTab !== MAKEUP_TAB) {
      handleLooksChange(looks[indexFinal], indexFinal);
    }
  };

  const resetVM = () => {
    closeVM();
    setVmState({
      lookCurrentlyApplied: -1,
      VMImageLoaded: false,
      loader: true,
      isMakeUpApplied: false,
      isLookApplied: false,
    });
    const timer = setTimeout(() => {
      setVmState({ loader: false });
      window.YMK && window.YMK.open();
      clearTimeout(timer);
    }, 2000);
  };

  const closeVM = () => {
    if (!state.loader && window.YMK) {
      window.YMK.close();
      setVmState({
        isLookApplied: false,
        isMakeUpApplied: false,
        VMImageLoaded: false,
      });
    }
  };

  const handleShadeChange = (shadeId, makeUpType) => {
    const { selectedMakeup } = state;
    selectedMakeup[makeUpType] = shadeId;
    setVmState({ selectedMakeup: selectedMakeup });
    window.YMK &&
      window.YMK.applyMakeupBySku(shadeId, (res) => {
        if (res) {
          setVmState({
            isMakeUpApplied: true,
            isLookApplied: false,
            VMImageLoaded: true,
          });
        }
      });
  };

  const startCompare = () => {
    window.YMK && window.YMK.enableCompare();
  };

  const startKissDetection = () => {
    window.YMK && window.YMK.enableKissDetection();
  };

  const handleLensOnLoad = () => {
    let recommendedLensIndex =
      (props && props.match && props.match.params.recommendation) || -1;
    if (!recommendedLensIndex) {
      //moving from makeup tab to lens tab, if no, then by default selected lens will be first lens.
      console.log('inside recommendedLensIndex equals 0');
      recommendedLensIndex = 0;
    }
    if (state.lensIndex > -1) {
      //if some lens is selected then update the recommendedLensIndex
      console.log('inside some lens is selected');
      recommendedLensIndex = state.lensIndex;
    }
    if (recommendedLensIndex > -1 && recommendedLensIndex < 7 && !lensCleared) {
      console.log('LensOnLoad: ', recommendedLensIndex);
      handleLensChange(recommendedLensIndex, 0, selectedLensType);
    }
  };

  const handleMakeUpCategoryChange = (selectedMakeupCategory) => {
    setVmState({ selectedMakeupCategory: selectedMakeupCategory });
  };

  const isLensTab = (tab) => {
    return tab === FRESH_LENS_TAB || tab === CLASSIC_LENS_TAB;
  };

  return (
    <Context.Provider
      value={{
        ...state,
        setVmState,
        onTabClick,
        removeAppliedMakeup,
        removeAppliedLook,
        resetSelectedMakeup,
        applyMakeUpOnLoad,
        applyMakeupByLook,
        applyMakeUpBySku,
        handleLensChange,
        handleLooksChange,
        looksLoaded,
        resetVM,
        closeVM,
        handleShadeChange,
        startCompare,
        startKissDetection,
        handleLensOnLoad,
        handleMakeUpCategoryChange,
        isLensTab,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export { ContextContainer };
